export default {
  getOrdersByAppId: (state, getters, rootState, rootGetters) => (appId) => {
    const mediation = rootGetters['monetization/currentMediation']
    return state.orders[mediation][appId]
  }
}
